// HUD visibility toggle (user 2026-10-10: "on the far right of the top panel we need an icon to
// toggle the entire hud. on desktop this also works with the tab key"): a small Material Icons
// button pinned to the top-right corner of the GUI viewport, OUTSIDE the LCARS frame so it stays
// when the frame is hidden. Hidden = every other gui child (frame, pages, overlays) invisible
// and not clickable. Tab (box-patcher's handler) toggles when no field is focused.
import { loadFontFamily, box } from 'imperial-lib';

const ICON_FONT = 'https://cdn.worldapi.org/imperial-text-base/google/material-icons/font.json';
const VISIBILITY = '', VISIBILITY_OFF = ''; // Material Icons codepoints (PUA)
export const ICON_VISIBILITY = VISIBILITY, ICON_VISIBILITY_OFF = VISIBILITY_OFF;
let iconFont = null;
export function ensureIconFont() {
	return iconFont || (iconFont = loadFontFamily(ICON_FONT));
}

export async function initHudToggle(game) {
	const font = await ensureIconFont();
	const state = game.hud || (game.hud = { hidden: false, button: null });
	if (state.button) { state.button.dispose?.(); state.button.parent?.remove(state.button); }
	const vp = globalThis.__guiViewport;
	const W = (vp && vp.width) || window.innerWidth, H = (vp && vp.height) || window.innerHeight;
	// the SAME rectangle and look as the frame's own toggle button (user 2026-10-16: "the eye icon
	// when hidden seems different in size and position, also its orange not white"): the frame's
	// hit proxy gives the size and position, its colours give the fill (frame colour) and glyph
	const frame = game.lcarsHud;
	const proxy = frame?.buttons?.hudToggle;
	let w = 36, h = 36, fontSize = 22, x = W / 2 - 20 - 18 - 2, y = H / 2 - 20 - 17;
	let fill = [0.03, 0.04, 0.09, 0.9], glyph = [1, 0.6, 0];
	if (proxy) {
		w = proxy.geometry.parameters.width;
		h = proxy.geometry.parameters.height;
		fontSize = 18; // hud-lcars.js toggleItem
		const p = game.gui.worldToLocal(proxy.getWorldPosition(new (proxy.position.constructor)()));
		x = p.x;
		y = p.y;
		fill = frame.color;
		glyph = frame.backgroundColor ?? [0.02, 0.02, 0.06, 1]; // imperial-lcars COLORS.btnText
	}
	const button = box({ width: w, height: h, text: state.hidden ? VISIBILITY : VISIBILITY_OFF, font, fontSize,
		color: glyph, textAlign: 'center', vAlign: 'middle', padding: [0, 0, 0, 0], borderRadii: [0, 0, 0, 0],
		backgroundColor: fill, clickable: true, onClick: () => toggleHud(game) });
	button.userData.hudToggle = true;
	button.userData.layoutIgnore = true;
	// gui: 1 unit = 1 px, origin at the viewport centre
	button.position.set(x, y, 1);
	button.renderOrder = (game.gui.renderOrder || 10000) + 200;
	button.traverse((o) => { if (o.material) { o.material.depthTest = false; o.renderOrder = button.renderOrder + (o.material.uniforms?.atlas ? 2 : 1); } });
	game.gui.add(button);
	state.button = button;
	applyHidden(game);
	if (!state.tabHandler) {
		state.tabHandler = (e) => {
			if (e.key !== 'Tab') return;
			let focused = false;
			game.gui.traverse((o) => { if (o.selection?.active) focused = true; });
			if (focused) return; // box-patcher's handler cycles the fields
			e.preventDefault();
			toggleHud(game);
		};
		window.addEventListener('keydown', state.tabHandler);
	}
	return button;
}

function applyHidden(game) {
	const hidden = game.hud.hidden;
	for (const c of game.gui.children) {
		if (c.userData?.hudNotice) { c.visible = !!c.userData.shown; continue; } // the order notice ignores the HUD toggle
		if (c.userData?.hudToggle) { c.visible = hidden; continue; } // the floating icon only while hidden
		c.visible = !hidden;
	}
	const b = game.hud.button;
	if (b?._textHandle?.setContent) b._textHandle.setContent(hidden ? VISIBILITY : VISIBILITY_OFF);
}

export function toggleHud(game, hidden = !game.hud?.hidden) {
	if (!game.hud) game.hud = { hidden: false, button: null };
	game.hud.hidden = hidden;
	applyHidden(game);
	return hidden;
}

// after a frame rebuild (VR relayout, login) the new children must follow the current state
export function syncHudVisibility(game) { if (game.hud) applyHidden(game); }
